<!-- 城市地图车辆分布数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkingCodes":["354","123"],
                "parkCode":"2KNTYVWC",
                "remark":"123",
                "enterTimeEnd":"202204010000"
                },
            responseCode: {
                    "data": {},
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取城市地图车辆分布数据",
                t_url: this.commonUrls.test+"inventoryCar",
                p_url: this.commonUrls.prod+"inventoryCar",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编号' },
                        { info1: 'parkingCodes', info2: '否', info3: 'JSONArray', info4: "停车记录列表List"+"&lt;"+"String"+"&gt; " },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号' },
                        { info1: 'carNos', info2: '否', info3: 'JSONArray', info4: "车场编码List"+"&lt;"+"String"+"&gt; " },
                        { info1: 'enterTimeEnd', info2: '是', info3: 'String', info4: '进场时间yyyyMMddHHmmss(盘点以这个时间为界限之前的停车记录)' },
                        { info1: 'remark', info2: '是', info3: 'String', info4: '备注' },
                        { info1: 'operator', info2: '否', info3: 'String', info4: '操作人' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/carSearch/inventoryCar.vue